var _jsxFileName = "/Users/kayote/Documents/ReactApps/fretboard-viz-tool/dependencies/react-fretboard/components/Fretboard/Skins/NutGraphicBoxes/index.js";
import React from 'react';

const NutGraphicBoxes = () => /*#__PURE__*/React.createElement("rect", {
  x: "5%",
  y: "2%",
  rx: "3",
  ry: "3",
  width: "90%",
  height: "96%",
  fill: "lightgray",
  stroke: "none",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 5,
    columnNumber: 3
  }
});

export default NutGraphicBoxes;










